import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { CardComponent } from 'shared';

import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { CompanyService } from '../../../domain/company/company.service';

export interface SideNavItem {
  label: string;
  route?: string[];
  iconName?: string;
  warning?: boolean;
  click?: () => void;
}

export interface SideNavSection {
  title?: string;
  items: SideNavItem[];
}

@Component({
  selector: 'app-side-nav-desktop',
  imports: [
    CardComponent,
    TranslateModule,
    RouterLink,
    RouterLinkActive,
    FeatherModule
],
  templateUrl: './side-nav-desktop.component.html',
  styleUrl: './side-nav-desktop.component.scss',
})
export class SideNavDesktopComponent {
  companyService = inject(CompanyService);

  sections = computed<SideNavSection[]>(() => [
    {
      title: 'Gateway',
      items: [
        {
          label: 'pending-requests',
          route: ['/pending-requests'],
          iconName: 'clock',
          warning: this.companyService.pendingCount() > 0,
        },
        {
          label: 'companies',
          route: ['/companies'],
          iconName: 'briefcase',
        },
        {
          label: 'reports',
          route: ['/reports'],
          iconName: 'file-text',
        },
        // {
        //   label: 'users',
        //   route: ['/users'],
        //   iconName: 'users',
        // },
      ],
    },
    // {
    //   title: 'resources',
    //   items: [
    //     {
    //       label: 'resources-guidance',
    //       route: ['/resources'],
    //       iconName: 'book',
    //     },
    //   ],
    // },
  ]);
}
